<template>
    <div>
        <div class="relative w-full">
            <div class="p-4 space-y-2">
                <div
                    v-for="(query, index) in queries"
                    :key="'and-query-' + index"
                    class="space-y-2"
                >
                    <div v-if="index > 0">
                        <span class="query-joiner">AND</span>
                    </div>
                    <div class="relative w-full">
                        <automation-or-query-maker
                            :query="query"
                            :options="options"
                            @change="syncQuery(index, $event)"
                        ></automation-or-query-maker>
                        <button
                            class="absolute -left-6 top-1/2 rounded-full px-2 py-1 font-bold text-xs text-destructive"
                            @click.prevent="removeQuery(index)"
                            v-if="index > 0"
                            style="transform: translateY(-50%)"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'times']"
                            ></font-awesome-icon>
                        </button>
                    </div>
                </div>
                <div>
                    <button
                        class="query-joiner"
                        @click.prevent="addAnotherQuery"
                    >
                        + AND
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            default: () => ({}),
        },
        query: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            queries: this.query.length > 0 ? this.query : [this.makeNewQuery()],
        };
    },
    methods: {
        removeQuery(index) {
            this.queries.splice(index, 1);
        },
        addAnotherQuery() {
            this.queries.push(this.makeNewQuery());
        },
        syncQuery(index, $event) {
            this.$set(this.queries, index, $event);
            this.$emit("change", this.queries);
        },
        makeNewQuery() {
            return [];
        },
    },
};
</script>

<style scoped>
span.query-joiner {
    @apply rounded-full px-2 py-1 font-bold text-xs;
}
button.query-joiner {
    @apply bg-primary-lighter text-primary rounded-full px-2 py-1 font-bold text-xs;
}
</style>
